import { findMessage } from '../../..';

const trMessages = {
	tr: {
		Yes: 'Evet',
		No: 'Hayır',
		Cancel: 'İptal',
		Clear: 'Temizle',
		Done: 'Tamam',
		Loading: 'Yükleniyor...',
		Select: 'Seç...',
		Search: 'Ara',
		Back: 'Geri',
		OK: 'Tamam',
		'dxCollectionWidget-noDataText': 'Gösterilecek bilgi yok',
		'validation-required': 'Zorunlu',
		'validation-required-formatted': '{0} gerekli',
		'validation-numeric': 'Değer bir sayı olmalı',
		'validation-numeric-formatted': '{0} bir sayı olmalı',
		'validation-range': 'Değer aralık dışında',
		'validation-range-formatted': '{0} aralık dışında',
		'validation-stringLength': 'Değerin uzunluğu doğru değil',
		'validation-stringLength-formatted': '{0} uzunluğu doğru değil',
		'validation-custom': 'Değer geçersiz',
		'validation-custom-formatted': '{0} geçersiz',
		'validation-compare': 'Değerler eşleşmiyor',
		'validation-compare-formatted': '{0} eşleşmiyor',
		'validation-pattern': 'Değer kalıpla eşleşmiyor',
		'validation-pattern-formatted': '{0} kalıpla eşleşmiyor',
		'validation-email': 'E-posta geçersiz',
		'validation-email-formatted': '{0} geçersiz',
		'validation-mask': 'Değer geçersiz',
		'dxLookup-searchPlaceholder': 'Minimum karakter sayısı: {0}',
		'dxList-pullingDownText': 'Yenilemek için aşağıya çekin...',
		'dxList-pulledDownText': 'Yenilemek için bırakın...',
		'dxList-refreshingText': 'Yenileniyor...',
		'dxList-pageLoadingText': 'Yükleniyor...',
		'dxList-nextButtonText': 'Daha',
		'dxList-selectAll': 'Tümünü Seç',
		'dxListEditDecorator-delete': 'Sil',
		'dxListEditDecorator-more': 'Daha',
		'dxScrollView-pullingDownText': 'Yenilemek için aşağıya çekin...',
		'dxScrollView-pulledDownText': 'Yenilemek için bırakın...',
		'dxScrollView-refreshingText': 'Yenileniyor...',
		'dxScrollView-reachBottomText': 'Yükleniyor...',
		'dxDateBox-simulatedDataPickerTitleTime': 'Saat seç',
		'dxDateBox-simulatedDataPickerTitleDate': 'Tarih seç',
		'dxDateBox-simulatedDataPickerTitleDateTime': 'Tarih ve saati seçin',
		'dxDateBox-validation-datetime': 'Değer bir tarih veya saat olmalıdır',
		'dxFileUploader-selectFile': 'Dosya seç',
		'dxFileUploader-dropFile': 'veya Dosyayı buraya bırakın',
		'dxFileUploader-bytes': 'bytes',
		'dxFileUploader-kb': 'kb',
		'dxFileUploader-Mb': 'Mb',
		'dxFileUploader-Gb': 'Gb',
		'dxFileUploader-upload': 'Yükleme',
		'dxFileUploader-uploaded': 'Yüklenen',
		'dxFileUploader-readyToUpload': 'Yüklemeye hazır',
		'dxFileUploader-uploadAbortedMessage': 'Yükleme iptal edildi',
		'dxFileUploader-uploadFailedMessage': 'Yükleme başarısız',
		'dxFileUploader-invalidFileExtension': 'Dosya türüne izin verilmiyor',
		'dxFileUploader-invalidMaxFileSize': 'Dosya çok büyük',
		'dxFileUploader-invalidMinFileSize': 'Dosya çok küçük',
		'dxRangeSlider-ariaFrom': 'İtibaren',
		'dxRangeSlider-ariaTill': 'Kadar',
		'dxSwitch-switchedOnText': 'Açık',
		'dxSwitch-switchedOffText': 'Kapalı',
		'dxForm-optionalMark': 'isteğe bağlı',
		'dxForm-requiredMessage': '{0} gerekli',
		'dxNumberBox-invalidValueMessage': 'Değer bir sayı olmalı',
		'dxNumberBox-noDataText': 'Veri yok',
		'dxDataGrid-columnChooserTitle': 'Sütun Seçici',
		'dxDataGrid-columnChooserEmptyText': 'Sütunu gizlemek için buraya sürükleyin',
		'dxDataGrid-groupContinuesMessage': 'Bir sonraki sayfada devam ediyor',
		'dxDataGrid-groupContinuedMessage': 'Önceki sayfadan devam',
		'dxDataGrid-groupHeaderText': 'Bu Sütuna Göre Grupla',
		'dxDataGrid-ungroupHeaderText': 'Grubu Kaldır',
		'dxDataGrid-ungroupAllText': 'Tüm Grupları Kaldır',
		'dxDataGrid-editingEditRow': 'Düzenle',
		'dxDataGrid-editingSaveRowChanges': 'Kaydet',
		'dxDataGrid-editingCancelRowChanges': 'İptal',
		'dxDataGrid-editingDeleteRow': 'Sil',
		'dxDataGrid-editingUndeleteRow': 'Silme',
		'dxDataGrid-editingConfirmDeleteMessage': 'Bu kaydı silmek istediğinize emin misiniz?',
		'dxDataGrid-validationCancelChanges': 'Değişiklikleri iptal et',
		'dxDataGrid-groupPanelEmptyText':
			'Bu sütuna göre gruplamak için bir sütun başlığını buraya sürükleyin',
		'dxDataGrid-noDataText': 'Veri yok',
		'dxDataGrid-searchPanelPlaceholder': 'Arama...',
		'dxDataGrid-filterRowShowAllText': '(Tümü)',
		'dxDataGrid-filterRowResetOperationText': findMessage.get('100888'),
		'dxDataGrid-filterRowOperationEquals': findMessage.get('101711'),
		'dxDataGrid-filterRowOperationNotEquals': findMessage.get('101712'),
		'dxDataGrid-filterRowOperationLess': findMessage.get('101715'),
		'dxDataGrid-filterRowOperationLessOrEquals': findMessage.get('101716'),
		'dxDataGrid-filterRowOperationGreater': findMessage.get('101713'),
		'dxDataGrid-filterRowOperationGreaterOrEquals': findMessage.get('101714'),
		'dxDataGrid-filterRowOperationStartsWith': findMessage.get('101720'),
		'dxDataGrid-filterRowOperationContains': findMessage.get('101718'),
		'dxDataGrid-filterRowOperationNotContains': findMessage.get('101719'),
		'dxDataGrid-filterRowOperationEndsWith': findMessage.get('101721'),
		'dxDataGrid-filterRowOperationBetween': 'Arasında',
		'dxDataGrid-filterRowOperationBetweenStartText': 'Başla',
		'dxDataGrid-filterRowOperationBetweenEndText': 'Bitiş',
		'dxDataGrid-applyFilterText': 'Filtre uygula',
		'dxDataGrid-trueText': 'Evet',
		'dxDataGrid-falseText': 'Hayır',
		'dxDataGrid-sortingAscendingText': findMessage.get('101723'),
		'dxDataGrid-sortingDescendingText': findMessage.get('101724'),
		'dxDataGrid-sortingClearText': 'Sıralamayı Temizle',
		'dxDataGrid-editingSaveAllChanges': 'Değişiklikleri Kaydet',
		'dxDataGrid-editingCancelAllChanges': 'Değişiklikleri iptal et',
		'dxDataGrid-editingAddRow': 'Satır ekle',
		'dxDataGrid-summaryMin': 'Min: {0}',
		'dxDataGrid-summaryMinOtherColumn': '{1} min: {0}',
		'dxDataGrid-summaryMax': 'Max: {0}',
		'dxDataGrid-summaryMaxOtherColumn': '{1} max: {0}',
		'dxDataGrid-summaryAvg': 'Ort: {0}',
		'dxDataGrid-summaryAvgOtherColumn': '{1} ortalaması: {0}',
		'dxDataGrid-summarySum': 'Top: {0}',
		'dxDataGrid-summarySumOtherColumn': '{1} toplamı: {0}',
		'dxDataGrid-summaryCount': 'Toplam: {0}',
		'dxDataGrid-columnFixingFix': 'Sabitle',
		'dxDataGrid-columnFixingUnfix': 'Çöz',
		'dxDataGrid-columnFixingLeftPosition': 'Sola',
		'dxDataGrid-columnFixingRightPosition': 'Sağa',
		'dxDataGrid-exportTo': 'Dışa aktar',
		'dxDataGrid-exportToExcel': 'Excel dosyasına aktar',
		'dxDataGrid-exporting': 'Dışa Aktarılıyor...',
		'dxDataGrid-excelFormat': 'Excel dosyası',
		'dxDataGrid-selectedRows': 'Seçili satırlar',
		'dxDataGrid-exportSelectedRows': 'Seçili satırları aktar',
		'dxDataGrid-exportAll': 'Tüm verileri dışa aktar',
		'dxDataGrid-headerFilterEmptyValue': '(Blanks)',
		'dxDataGrid-headerFilterOK': 'Tamam',
		'dxDataGrid-headerFilterCancel': 'İptal',
		'dxDataGrid-ariaColumn': 'Sütun',
		'dxDataGrid-ariaValue': 'Veri',
		'dxDataGrid-ariaFilterCell': 'Filtre hücresi',
		'dxDataGrid-ariaCollapse': 'Daralt',
		'dxDataGrid-ariaExpand': 'Genişlet',
		'dxDataGrid-ariaDataGrid': 'Tablo',
		'dxDataGrid-ariaSearchInGrid': 'Tabloda ara',
		'dxDataGrid-ariaSelectAll': 'Hepsini seç',
		'dxDataGrid-ariaSelectRow': 'Satırı seç',
		'dxDataGrid-filterBuilderPopupTitle': 'Filtre Oluşturucu',
		'dxDataGrid-filterPanelCreateFilter': 'Filtre Oluştur',
		'dxDataGrid-filterPanelClearFilter': 'Temizle',
		'dxDataGrid-filterPanelFilterEnabledHint': 'Filtreyi etkinleştir',
		'dxTreeList-ariaTreeList': 'Ağaç listesi',
		'dxTreeList-editingAddRowToNode': 'Ekle',
		'dxPager-infoText': 'Sayfa {0} / {1} ({2} veri)',
		'dxPager-pagesCountText': 'arasında',
		'dxPager-pageSizesAllText': 'Tümü',
		'dxPivotGrid-grandTotal': 'Genel Toplam',
		'dxPivotGrid-total': '{0} Toplam',
		'dxPivotGrid-fieldChooserTitle': 'Alan Seçici',
		'dxPivotGrid-showFieldChooser': 'Alan Seçiciyi Göster',
		'dxPivotGrid-expandAll': 'Tümünü Genişlet',
		'dxPivotGrid-collapseAll': 'Tümünü Daralt',
		'dxPivotGrid-sortColumnBySummary': '"{0}" Bu Sütuna Göre Sırala',
		'dxPivotGrid-sortRowBySummary': '"{0}" Bu Satıra Göre Sırala',
		'dxPivotGrid-removeAllSorting': 'Tüm Sıralamaları Kaldır',
		'dxPivotGrid-dataNotAvailable': 'N/A',
		'dxPivotGrid-rowFields': 'Satır Alanları',
		'dxPivotGrid-columnFields': 'Sütun Alanları',
		'dxPivotGrid-dataFields': 'Veri Alanları',
		'dxPivotGrid-filterFields': 'Filtre Alanları',
		'dxPivotGrid-allFields': 'Tüm Alanlar',
		'dxPivotGrid-columnFieldArea': 'Sütun Alanlarını Buraya Bırak',
		'dxPivotGrid-dataFieldArea': 'Veri Alanlarını Buraya Bırak',
		'dxPivotGrid-rowFieldArea': 'Satır Alanlarını Buraya Bırak',
		'dxPivotGrid-filterFieldArea': 'Filtre Alanlarını Buraya Bırak',
		'dxScheduler-editorLabelTitle': 'Konu',
		'dxScheduler-editorLabelStartDate': 'Başlangıç Tarihi',
		'dxScheduler-editorLabelEndDate': 'Bitiş Tarihi',
		'dxScheduler-editorLabelDescription': 'Açıklama',
		'dxScheduler-editorLabelRecurrence': 'Tekrar',
		'dxScheduler-openAppointment': 'Randevu Aç',
		'dxScheduler-recurrenceNever': 'Asla',
		'dxScheduler-recurrenceMinutely': 'Minutely',
		'dxScheduler-recurrenceHourly': 'Hourly',
		'dxScheduler-recurrenceDaily': 'Günlük',
		'dxScheduler-recurrenceWeekly': 'Haftalık',
		'dxScheduler-recurrenceMonthly': 'Aylık',
		'dxScheduler-recurrenceYearly': 'Yıllık',
		'dxScheduler-recurrenceRepeatEvery': 'Her tekrarla',
		'dxScheduler-recurrenceRepeatOn': 'Tekrarla',
		'dxScheduler-recurrenceEnd': 'Tekrarı bitir',
		'dxScheduler-recurrenceAfter': 'Sonra',
		'dxScheduler-recurrenceOn': 'İle',
		'dxScheduler-recurrenceRepeatMinutely': 'minute(s)',
		'dxScheduler-recurrenceRepeatHourly': 'hour(s)',
		'dxScheduler-recurrenceRepeatDaily': 'günler',
		'dxScheduler-recurrenceRepeatWeekly': 'haftalar',
		'dxScheduler-recurrenceRepeatMonthly': 'aylar',
		'dxScheduler-recurrenceRepeatYearly': 'yıllar',
		'dxScheduler-switcherDay': 'Gün',
		'dxScheduler-switcherWeek': 'Hafta',
		'dxScheduler-switcherWorkWeek': 'Çalışma Haftası',
		'dxScheduler-switcherMonth': 'Ay',
		'dxScheduler-switcherAgenda': 'Ajanda',
		'dxScheduler-switcherTimelineDay': 'Zaman Çizelgesi Günü',
		'dxScheduler-switcherTimelineWeek': 'Zaman Çizelgesi Haftası',
		'dxScheduler-switcherTimelineWorkWeek': 'Zaman Çizelgesi Çalışma Haftası',
		'dxScheduler-switcherTimelineMonth': 'TZaman Çizelgesi Çalışma Ayı',
		'dxScheduler-recurrenceRepeatOnDate': 'tarihinde',
		'dxScheduler-recurrenceRepeatCount': 'olaylar',
		'dxScheduler-allDay': 'Tüm gün',
		'dxScheduler-confirmRecurrenceEditMessage':
			'Yalnızca bu randevuyu veya tüm diziyi düzenlemek ister misiniz?',
		'dxScheduler-confirmRecurrenceDeleteMessage':
			'Yalnızca bu randevuyu veya tüm diziyi silmek istiyor musunuz?',
		'dxScheduler-confirmRecurrenceEditSeries': 'Serileri düzenle',
		'dxScheduler-confirmRecurrenceDeleteSeries': 'Serileri sil',
		'dxScheduler-confirmRecurrenceEditOccurrence': 'Randevuyu düzenle',
		'dxScheduler-confirmRecurrenceDeleteOccurrence': 'Randevuyu sil',
		'dxScheduler-noTimezoneTitle': 'Saat dilimi yok',
		'dxScheduler-moreAppointments': '{0} daha',
		'dxCalendar-todayButtonText': 'Bugün',
		'dxCalendar-ariaWidgetName': 'Takvim',
		'dxColorView-ariaRed': 'Kırmızı',
		'dxColorView-ariaGreen': 'Yeşil',
		'dxColorView-ariaBlue': 'Mavi',
		'dxColorView-ariaAlpha': 'Şeffaflık',
		'dxColorView-ariaHex': 'Renk kodu',
		'dxTagBox-selected': '{0} seçili',
		'dxTagBox-allSelected': 'Tümü seçildi ({0})',
		'dxTagBox-moreSelected': '{0} daha',
		'vizExport-printingButtonText': 'Yazdır',
		'vizExport-titleMenuText': 'Dışa Aktar/Yazdır',
		'vizExport-exportButtonText': '{0} dosya',
		'dxFilterBuilder-and': 'Ve',
		'dxFilterBuilder-or': 'Veya',
		'dxFilterBuilder-notAnd': 'Değil Ve',
		'dxFilterBuilder-notOr': 'Değil Veya',
		'dxFilterBuilder-addCondition': 'Koşul Ekle',
		'dxFilterBuilder-addGroup': 'Grup Ekle',
		'dxFilterBuilder-enterValueText': '<değer gir>',
		'dxFilterBuilder-filterOperationEquals': 'Eşit',
		'dxFilterBuilder-filterOperationNotEquals': 'Eşit değil',
		'dxFilterBuilder-filterOperationLess': 'Daha küçük',
		'dxFilterBuilder-filterOperationLessOrEquals': 'Daha küçük veya eşit',
		'dxFilterBuilder-filterOperationGreater': 'Daha büyük',
		'dxFilterBuilder-filterOperationGreaterOrEquals': 'Daha büyük veya eşit',
		'dxFilterBuilder-filterOperationStartsWith': 'İle başlar',
		'dxFilterBuilder-filterOperationContains': 'İçerir',
		'dxFilterBuilder-filterOperationNotContains': 'İçermez',
		'dxFilterBuilder-filterOperationEndsWith': 'İle biter',
		'dxFilterBuilder-filterOperationIsBlank': 'Boş',
		'dxFilterBuilder-filterOperationIsNotBlank': 'Boş değil',
		'dxFilterBuilder-filterOperationBetween': 'Arasında',
		'dxFilterBuilder-filterOperationAnyOf': 'Herhangi biri',
		'dxFilterBuilder-filterOperationNoneOf': 'Hiçbiri',
		'dxHtmlEditor-dialogColorCaption': 'Yazı Tipi Rengini Değiştir',
		'dxHtmlEditor-dialogBackgroundCaption': 'Arka Plan Rengini Değiştir',
		'dxHtmlEditor-dialogLinkCaption': 'Link Ekle',
		'dxHtmlEditor-dialogLinkUrlField': 'URL',
		'dxHtmlEditor-dialogLinkTextField': 'Metin',
		'dxHtmlEditor-dialogLinkTargetField': 'Linki yeni pencerede aç',
		'dxHtmlEditor-dialogImageCaption': 'Resim Ekle',
		'dxHtmlEditor-dialogImageUrlField': 'URL',
		'dxHtmlEditor-dialogImageAltField': 'Alternatif metin',
		'dxHtmlEditor-dialogImageWidthField': 'Genişlik (px)',
		'dxHtmlEditor-dialogImageHeightField': 'Yükseklik (px)',
		'dxHtmlEditor-dialogInsertTableRowsField': '!TODO',
		'dxHtmlEditor-dialogInsertTableColumnsField': '!TODO',
		'dxHtmlEditor-dialogInsertTableCaption': '!TODO',
		'dxHtmlEditor-heading': 'Başlık',
		'dxHtmlEditor-normalText': 'Normal metin'
	}
};

export default trMessages;
